export interface ContactFormValues {
    country:string,
    countryCode: number;
    phone: number;
    email: string;
}
